import { useEffect } from "react";
import { initPropertyPageTracking, trackValuationRequest, trackCTAClick } from "@/lib/analytics";
import CityHero from "./CityHero";
import ManchesterKeyBenefits from "../manchester/ManchesterKeyBenefits";
import ManchesterEarningsExplorer from "../manchester/ManchesterEarningsExplorer";
import ManchesterLandlordProof from "../manchester/ManchesterLandlordProof";
import WhatWeHandle from "../manchester/WhatWeHandle";
import ManchesterHowItWorks from "../manchester/ManchesterHowItWorks";
import ManchesterRiskReversal from "../manchester/ManchesterRiskReversal";
import ManchesterShortLetCase from "../manchester/ManchesterShortLetCase";
import ManchesterContact from "../manchester/ManchesterContact";
import GuestExperience from "../manchester/GuestExperience";
import ManchesterDistribution from "../manchester/ManchesterDistribution";
import ManchesterFAQNew from "../manchester/ManchesterFAQNew";
import ManchesterPropertyTypes from "../manchester/ManchesterPropertyTypes";
import ManchesterFinalCTA from "../manchester/ManchesterFinalCTA";

export default function CityManagementPage({ config }) {
  useEffect(() => {
    const cleanup = initPropertyPageTracking(config.path);
    window.trackValuationRequest = () => trackValuationRequest(config.cityName);
    window.trackCTAClick = (type) => trackCTAClick(type, config.cityName);

    document.title = config.metaTitle;

    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.name = name; document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setOgMeta = (property, content) => {
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("property", property); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };

    setMeta("description", config.metaDescription);
    setMeta("robots", "index, follow");
    setOgMeta("og:type", "website");
    setOgMeta("og:title", config.metaTitle);
    setOgMeta("og:description", config.metaDescription);
    setOgMeta("og:url", window.location.origin + config.path);
    if (config.ogImage) setOgMeta("og:image", config.ogImage);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
    canonical.href = `https://truestays.co.uk${config.path}`;

    const schemaId = `ts-schema-${config.slug}`;
    let existingScript = document.getElementById(schemaId);
    if (existingScript) existingScript.remove();
    const script = document.createElement("script");
    script.id = schemaId;
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        { "@type": "LocalBusiness", "@id": `https://truestays.co.uk${config.path}`, "name": `Truestays — Airbnb Management ${config.cityName}`, "description": `Full-service Airbnb and short-let management in ${config.cityName} from 12% + VAT.`, "url": `https://truestays.co.uk${config.path}`, "priceRange": "From 12% + VAT", "areaServed": { "@type": "City", "name": config.cityName }, "aggregateRating": { "@type": "AggregateRating", "ratingValue": "5.0", "reviewCount": "90", "bestRating": "5" } },
        { "@type": "BreadcrumbList", "itemListElement": [{ "@type": "ListItem", "position": 1, "name": "Home", "item": "https://truestays.co.uk/" }, { "@type": "ListItem", "position": 2, "name": "Management", "item": "https://truestays.co.uk/management/" }, { "@type": "ListItem", "position": 3, "name": config.cityName, "item": `https://truestays.co.uk${config.path}` }] }
      ]
    });
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById(schemaId);
      if (s) s.remove();
      cleanup();
    };
  }, [config]);

  return (
    <>
      <CityHero config={config} />
      <ManchesterKeyBenefits config={config} />
      <ManchesterEarningsExplorer config={config} />
      <ManchesterLandlordProof config={config} />
      <WhatWeHandle />
      <ManchesterHowItWorks />
      <ManchesterRiskReversal config={config} />
      <ManchesterShortLetCase config={config} />
      <ManchesterContact config={config} />
      <GuestExperience />
      <ManchesterDistribution />
      <ManchesterFAQNew config={config} />
      <ManchesterPropertyTypes config={config} />
      <ManchesterFinalCTA config={config} />
    </>
  );
}